import classnames from "classnames";
import React from "react";
import { Icon, Select } from "src/components";
import theme from "src/theme";
import styled from "styled-components";

const SelectWrapper = styled(Select)`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  height: 100%;

  &:hover .select-label {
    opacity: 0.7;
    background-color: inherit;
  }

  .select-label {
    padding-top: 0;
    padding-bottom: 0;
  }

  .select-options {
    max-height: 20vh;
    top: calc(100% + 1px);
    left: 0;
    margin: 0;
    z-index: 1;
    text-align: center;
    box-shadow: 1px 3px 5px ${theme.colors.shadow};
    overflow: auto;
  }

  .select-option {
    border-bottom: 1px solid ${theme.colors.lightGrey};
  }
`;

const SelectLabel = styled.div``;
const SelectLabelIcon = styled(Icon)``;

interface IProps {
  className?: string;
  quantity: number;
  options: number[];
  onChange: (quantity: number) => void;
}

const QuantitySelect = ({
  className,
  quantity,
  options,
  onChange,
}: IProps): JSX.Element => {
  return (
    <SelectWrapper
      className={classnames("select-quantity", className)}
      label={
        <>
          <SelectLabel className="selected-option">{quantity}</SelectLabel>
          <SelectLabelIcon
            className="selected-option-button"
            name="chevron-bas"
            size={22}
          />
        </>
      }
      options={options.map((label) => ({ label }))}
      onChange={(option): void => onChange(option.label as number)}
    />
  );
};

export default QuantitySelect;
